import React, { useContext } from 'react'
import { connect } from 'react-redux'
import { FormContext } from './formContext'
import { modes } from './propertyRenderer'
import {
  approvalSummarySelector
} from '@/components/changeRequests/selectors'
import { ApprovalBadges } from '@/components/changeRequests/approvalBadges'

let ApprovalSummary = (props) => {
  const { mode, isChangeItemId } = useContext(FormContext)
  return (
    mode === modes.approval && isChangeItemId
      ? <ApprovalBadges badges={props.badges} mode={mode} />
      : null
  )
}

function mapStateToProps (state, ownProps) {
  return {
    badges: approvalSummarySelector(state, ownProps),
    ...ownProps
  }
}

ApprovalSummary = connect(mapStateToProps)(ApprovalSummary)

export {
  ApprovalSummary
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/approvalSummary.js